'use strict';

/**
 * footer decorator implementation for the accordion module.
 *
 * @author Mathias Hayoz <mathias.hayoz@namics.com>
 */
T.Module.Accordion.Footer = T.createDecorator({

	_selectors: {
		panel: '[data-js-o-accordion__panel]',
		title: '[data-js-o-accordion-title]',
		toggle: '[data-js-o-accordion__toggle]',
		icons: '.h-icon',
		linklist: 'm-linklist',
		gridQuarter: 'g-quarter',
		gridThird: 'g-third'
	},

	_stateClasses: {
		open: 'state-open',
		closed: 'state-closed'
	},

	handleClick: function handleClick(event) {
		if (this.isDesktop) {
			return false;
		}

		// we only need the click handling on small screen
		this._parent.handleClick(event);
	},
	start: function start(resolve) {
		this.$ctx = $(this._ctx);

		// References
		this.$icons = this.$ctx.find(this._selectors.toggle + ' ' + this._selectors.icons);
		this.$panels = this.$ctx.find(this._selectors.panel);

		// Global Event Binding
		this._events.on('viewport.match', this.onViewportMatch.bind(this));

		this.transformQuarterToThirdWhenLastColMissing();

		this._parent.start(resolve);
	},
	onViewportMatch: function onViewportMatch(wpName) {
		switch (wpName) {
			case 'small-down':
				this.mobile();
				break;
			case 'medium-up':
				this.desktop();
				break;
			default:
				break;
		}
	},


	/**
  * There is a special case when the third layout is used, but some links are provided.
  * In this case, we switch from quarter to third.
  *
  * Workaround for an issue that surfaced with RUAGWEB-448.
  *
  * @returns {void}
  */
	transformQuarterToThirdWhenLastColMissing: function transformQuarterToThirdWhenLastColMissing() {
		var $layout = this.$ctx.children().first();
		var isQuarter = $layout.hasClass(this._selectors.gridQuarter);

		if (isQuarter && this.$panels.length === 3) {
			$layout.removeClass(this._selectors.gridQuarter);
			$layout.addClass(this._selectors.gridThird);
		}
	},


	/**
  * Adapt Footer for Mobile by concatenating the second and third row, if this is desired.
  *
  * @returns {void}
  */
	mobile: function mobile() {
		this.isDesktop = false;
		$(this._selectors.toggle, this.$ctx).removeClass(this._stateClasses.open);
		this.$panels.slideUp();
		this.$icons.show();

		// Stencil Footer revert to two accordion panels
		if (this.$panels.length === 3 && !this.initialSecondRowContent && !this.isLinklistInPanel()) {
			var thirdPanel = $(this.$panels[2]);
			this.initialSecondRowContent = $(this.$panels[1]).html();
			this.thirdRowContent = thirdPanel.html();
			var secondPanel = $(this.$panels[1]);

			secondPanel.append(this.thirdRowContent);
			thirdPanel.parent().hide();
		}
	},


	/**
  * Adapt Footer for Desktop.
  *
  * @returns {void}
  */
	desktop: function desktop() {
		this.isDesktop = true;
		if (!this.$ctx.hasClass(this._stateClasses.open) && !this.$ctx.hasClass(this._stateClasses.closed)) {
			this.$panels.show();
		} else {
			this.$panels.slideDown();
		}

		this.$icons.hide();

		// Stencil Footer Default Three accordion panels
		if (this.$panels.length < 4 && this.thirdRowContent) {
			var thirdPanel = $(this.$panels[2]);
			var secondPanel = $(this.$panels[1]);

			thirdPanel.parent().show();
			secondPanel.html(this.initialSecondRowContent);

			this.initialSecondRowContent = undefined;
		}
	},


	/**
  * We only consolidate the second and third column if the middle column is not a linklist.
  *
  * @returns {boolean} Whether there was a linklist found.
  */
	isLinklistInPanel: function isLinklistInPanel() {
		var _this = this;

		var match = false;

		this.$panels.children().each(function (index, child) {
			if ($(child).hasClass(_this._selectors.linklist)) {
				match = true;
			}
		});

		return match;
	}
});